// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2aAuw","title":"Info_title__1rVK_","selects":"Info_selects__20c4-","requiredAsterisk":"Info_requiredAsterisk__2BwJj"};